import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SapError } from 'src/app/lego-utils';
import { max } from 'lodash';
import { map, Observable } from 'rxjs';
import { INotificationActivityCreate } from 'src/app/state/notification-activity-create.model';
import { INotificationActivity } from 'src/app/state/notification-activity.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationActivityApiService {
  public constructor(private readonly httpClient: HttpClient) {}

  public getNotificationNumber(designId: string): Observable<string> {
    return this.httpClient.get<string[]>(`api/notification-activity/${designId}`).pipe(
      map((response) => {
        const res = response[0];

        if (!res) {
          throw new SapError('Could not find notification number. You need to go to SAP for this.');
        }

        return res;
      })
    );
  }

  public getNextActivityNumber(designId: string): Observable<string> {
    return this.httpClient
      .get<INotificationActivity[]>(`api/notification-activity/${designId}`)
      .pipe(
        map((response) => {
          if (response.find((activity) => activity.activityCode === '40C')) {
            return '';
          }

          const newActivityNumber = max(
            response
              .map((x) => x.activityNumber)
              .filter((x): x is string => !!x)
              .map((x) => parseInt(x, 10))
          );

          if (!newActivityNumber) {
            return '0001';
          }

          return (newActivityNumber + 1).toString().padStart(4, '0');
        })
      );
  }

  public postNotificationActivity(
    designId: string,
    activity: string,
    notificationNumber: string
  ): Observable<INotificationActivity> {
    const notificationActivity: INotificationActivityCreate = {
      ActivityCode: '40C',
      ActivityNumber: activity,
      CatalogType: 'W',
      CodeGroup: 'QA-UOM',
      MaterialNumber: designId,
      NotificationNumber: notificationNumber,
    };

    return this.httpClient.post<INotificationActivity>(
      `api/notification-activity/${designId}`,
      notificationActivity
    );
  }
}
